import { useState, useEffect, useCallback } from "react";
import THEME from "../../../theme";
import { useBreite, BREAKPOINT_KLEIN } from "../ui/Bausteine";
import { fs } from "../utils/styles";
import { finanzenApi } from "../services/finanzenApi";

const FELDER = [
  { value: "zahlungspartner", label: "Zahlungspartner" },
  { value: "iban", label: "IBAN" },
  { value: "buchungstext", label: "Buchungstext" },
  { value: "verwendungszweck", label: "Verwendungszweck" },
  { value: "betrag", label: "Betrag" },
  { value: "mandatsreferenz", label: "Mandatsreferenz" },
  { value: "glaeubiger_id", label: "Gläubiger-ID" },
  { value: "buchungsart", label: "Buchungsart" },
];
const OPERATOREN = [
  { value: "enthaelt", label: "enthält" },
  { value: "entspricht", label: "entspricht" },
  { value: "beginnt_mit", label: "beginnt mit" },
  { value: "endet_mit", label: "endet mit" },
  { value: "regex", label: "regulärer Ausdruck" },
  { value: "betrag_entspricht", label: "Betrag entspricht" },
  { value: "betrag_zwischen", label: "Betrag zwischen (von,bis)" },
];

const FINANZSTATUS_OPTIONEN = [
  { value: "", label: "– unverändert –" },
  { value: "betriebsrelevant", label: "Betriebsrelevant" },
  { value: "privat", label: "Privat" },
  { value: "neutral", label: "Neutral" },
  { value: "ignorieren", label: "Ignorieren" },
];

const LEERE_REGEL = { name: "", prioritaet: 0, feld: "verwendungszweck", operator: "enthaelt", vergleichswert: "", kategorie_id: "", setzt_finanzstatus: "" };

export default function FinanzRegelnSeite({ benutzerId }) {
  const breite = useBreite();
  const [regeln, setRegeln] = useState([]);
  const [kategorien, setKategorien] = useState([]);
  const [form, setForm] = useState(LEERE_REGEL);
  const [fehler, setFehler] = useState("");
  const [speichert, setSpeichert] = useState(false);

  const laden = useCallback(() => {
    finanzenApi.regelnListe(benutzerId).then(setRegeln).catch(e => setFehler(e.message));
  }, [benutzerId]);

  useEffect(() => { laden(); }, [laden]);
  useEffect(() => { finanzenApi.kategorienListe(benutzerId).then(setKategorien).catch(() => {}); }, [benutzerId]);

  const kategorieName = (id) => kategorien.find(k => k.id === id)?.name || "–";

  const erstellen = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.vergleichswert.trim()) return;
    setSpeichert(true);
    setFehler("");
    try {
      await finanzenApi.regelErstellen(benutzerId, {
        ...form,
        kategorie_id: form.kategorie_id ? Number(form.kategorie_id) : null,
        setzt_finanzstatus: form.setzt_finanzstatus || null,
        prioritaet: Number(form.prioritaet) || 0,
      });
      setForm(LEERE_REGEL);
      laden();
    } catch (e) {
      setFehler(e.message);
    }
    setSpeichert(false);
  };

  const aktivUmschalten = async (regel) => {
    try {
      await finanzenApi.regelAktivSetzen(benutzerId, regel.id, !regel.aktiv);
      laden();
    } catch (e) {
      setFehler(e.message);
    }
  };

  const loeschen = async (id) => {
    if (!window.confirm("Regel wirklich löschen?")) return;
    try {
      await finanzenApi.regelLoeschen(benutzerId, id);
      laden();
    } catch (e) {
      setFehler(e.message);
    }
  };

  const schmal = breite < BREAKPOINT_KLEIN;
  return (
    <div>
      <form onSubmit={erstellen} style={{ ...fs.karte, display: "flex", gap: 12, flexWrap: "wrap", alignItems: "flex-end" }}>
        <div style={{ minWidth: 160 }}>
          <label style={fs.label}>Name</label>
          <input style={fs.input} value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="z.B. Mietregel" />
        </div>
        <div>
          <label style={fs.label}>Feld</label>
          <select style={fs.input} value={form.feld} onChange={e => setForm(f => ({ ...f, feld: e.target.value }))}>
            {FELDER.map(f => <option key={f.value} value={f.value}>{f.label}</option>)}
          </select>
        </div>
        <div>
          <label style={fs.label}>Operator</label>
          <select style={fs.input} value={form.operator} onChange={e => setForm(f => ({ ...f, operator: e.target.value }))}>
            {OPERATOREN.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </div>
        <div style={{ minWidth: 160 }}>
          <label style={fs.label}>Vergleichswert</label>
          <input style={fs.input} value={form.vergleichswert} onChange={e => setForm(f => ({ ...f, vergleichswert: e.target.value }))} placeholder="z.B. Miete" />
        </div>
        <div>
          <label style={fs.label}>Kategorie</label>
          <select style={fs.input} value={form.kategorie_id} onChange={e => setForm(f => ({ ...f, kategorie_id: e.target.value }))}>
            <option value="">– keine –</option>
            {kategorien.map(k => <option key={k.id} value={k.id}>{k.name}</option>)}
          </select>
        </div>
        <div>
          <label style={fs.label}>Finanzstatus setzen</label>
          <select style={fs.input} value={form.setzt_finanzstatus} onChange={e => setForm(f => ({ ...f, setzt_finanzstatus: e.target.value }))}>
            {FINANZSTATUS_OPTIONEN.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </div>
        <div style={{ width: 90 }}>
          <label style={fs.label}>Priorität</label>
          <input type="number" style={fs.input} value={form.prioritaet} onChange={e => setForm(f => ({ ...f, prioritaet: e.target.value }))} />
        </div>
        <button style={fs.btn} type="submit" disabled={speichert}>{speichert ? "Speichert…" : "Regel anlegen"}</button>
      </form>

      {fehler && <p style={{ color: THEME.colors.danger }}>{fehler}</p>}

      {schmal && (
        <div style={{ display: "grid", gap: 10 }}>
          {regeln.map(r => (
            <div key={r.id} style={{ background: THEME.colors.surface, borderRadius: THEME.radius.lg, padding: "12px 14px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}><strong>{r.name}</strong><span style={{ color: THEME.colors.textMuted }}>Prio {r.prioritaet}</span></div>
              <div style={{ color: THEME.colors.textSecondary, margin: "4px 0", overflowWrap: "anywhere" }}>{FELDER.find(f => f.value === r.feld)?.label || r.feld} {OPERATOREN.find(o => o.value === r.operator)?.label || r.operator} „{r.vergleichswert}"</div>
              <div style={{ fontSize: THEME.fontSize.sm, color: THEME.colors.textMuted }}>Kategorie: {kategorieName(r.kategorie_id)} · Finanzstatus: {FINANZSTATUS_OPTIONEN.find(o => o.value === r.setzt_finanzstatus)?.label.replace("– unverändert –", "–") || "–"}</div>
              <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                <button onClick={() => aktivUmschalten(r)} style={{ ...fs.btnGray, padding: "4px 10px", background: r.aktiv ? THEME.colors.success : THEME.colors.surfaceMuted }}>{r.aktiv ? "Aktiv" : "Inaktiv"}</button>
                <button onClick={() => loeschen(r.id)} style={fs.btnDanger}>Löschen</button>
              </div>
            </div>
          ))}
          {regeln.length === 0 && <div style={{ color: THEME.colors.textMuted }}>Noch keine Regeln.</div>}
        </div>
      )}
      {!schmal && <div style={fs.tabelle}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={fs.th}>Prio</th><th style={fs.th}>Name</th><th style={fs.th}>Bedingung</th>
              <th style={fs.th}>Kategorie</th><th style={fs.th}>Finanzstatus</th><th style={fs.th}>Aktiv</th><th style={fs.th}></th>
            </tr>
          </thead>
          <tbody>
            {regeln.map(r => (
              <tr key={r.id}>
                <td style={fs.td}>{r.prioritaet}</td>
                <td style={fs.td}>{r.name}</td>
                <td style={fs.td}>
                  {FELDER.find(f => f.value === r.feld)?.label || r.feld} {OPERATOREN.find(o => o.value === r.operator)?.label || r.operator} „{r.vergleichswert}"
                </td>
                <td style={fs.td}>{kategorieName(r.kategorie_id)}</td>
                <td style={fs.td}>{FINANZSTATUS_OPTIONEN.find(o => o.value === r.setzt_finanzstatus)?.label.replace("– unverändert –", "–") || "–"}</td>
                <td style={fs.td}>
                  <button onClick={() => aktivUmschalten(r)}
                    style={{ ...fs.btnGray, padding: "4px 10px", background: r.aktiv ? THEME.colors.success : THEME.colors.surfaceMuted }}>
                    {r.aktiv ? "Aktiv" : "Inaktiv"}
                  </button>
                </td>
                <td style={fs.td}>
                  <button onClick={() => loeschen(r.id)} style={fs.btnDanger}>Löschen</button>
                </td>
              </tr>
            ))}
            {regeln.length === 0 && <tr><td style={fs.td} colSpan={7}>Noch keine Regeln.</td></tr>}
          </tbody>
        </table>
      </div>}
    </div>
  );
}
